import styled from 'styled-components';
import { PublicPageLayout } from '../components/PublicPageLayout';

const Intro = styled.p`
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.7;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const StudioCallout = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing.lg};
  margin-bottom: ${({ theme }) => theme.spacing.xxl};
  text-align: center;
`;

const StudioName = styled.a`
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  background: linear-gradient(135deg, #3B82F6, #8B5CF6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-decoration: none;
  letter-spacing: 0.04em;

  &:hover { opacity: 0.85; }
`;

const StudioTag = styled.p`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: ${({ theme }) => theme.spacing.xs};
`;

const SectionLabel = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.textMuted};
  letter-spacing: 0.18em;
  text-transform: uppercase;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const FoundersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: ${({ theme }) => theme.spacing.xl};
`;

const FounderCard = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing.xl};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const FounderPhoto = styled.img`
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid ${({ theme }) => theme.colors.border};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const FounderName = styled.h3`
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 4px;
`;

const FounderRole = styled.p`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const FounderLink = styled.a`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.textSecondary};
  text-decoration: none;
  border-bottom: 1px dashed ${({ theme }) => theme.colors.border};
  padding-bottom: 2px;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    border-color: currentColor;
  }
`;

export function AboutPage() {
  return (
    <PublicPageLayout
      title="About Us"
      subtitle="The people behind Coopen SMM."
    >
      <Intro>
        Coopen SMM is a platform designed to help agencies and brands
        produce social-media content at scale — without losing identity
        or quality. It was born from a pragmatic blend of engineering and real
        market experience, built by people who lived both ends of the problem
        firsthand.
      </Intro>

      <StudioCallout>
        <SectionLabel>Crafted by</SectionLabel>
        <StudioName href="https://CoopenStudio.com/" target="_blank" rel="noopener noreferrer">
          Coopen Studios
        </StudioName>
        <StudioTag>CoopenStudio.com — a lab for useful digital products.</StudioTag>
      </StudioCallout>

      <SectionLabel>Founders</SectionLabel>
      <FoundersGrid>
        <FounderCard>
          <FounderPhoto src="/founder-charly.jpg" alt="Charly Centurion" />
          <FounderName>Charly Centurion</FounderName>
          <FounderRole>Co-Founder &amp; Developer</FounderRole>
          <FounderLink href="https://CodeCharly.com" target="_blank" rel="noopener noreferrer">
            CodeCharly.com
          </FounderLink>
        </FounderCard>

        <FounderCard>
          <FounderPhoto src="/founder-darin.jpg" alt="Darin Zogopoulos" />
          <FounderName>Darin Zogopoulos</FounderName>
          <FounderRole>Co-Founder &amp; Initial Investor</FounderRole>
          <FounderLink href="https://clearfuturecs.com/" target="_blank" rel="noopener noreferrer">
            clearfuturecs.com
          </FounderLink>
        </FounderCard>
      </FoundersGrid>
    </PublicPageLayout>
  );
}
